import { Link, useLocation } from 'react-router-dom';
import { Package, Shirt, Undo } from 'lucide-react';
import {
  SWISS_HEADER,
  SWISS_TYPOGRAPHY,
  SWISS_TOUCH,
  SWISS_TRANSITIONS,
  swissClass
} from '@/shared/utils/swissStyle';

/**
 * MainNavigation - Menu di navigazione principale orizzontale per Shop
 *
 * Design: Swiss Style con active state chiaro e touch-friendly
 * Posizionamento: Sticky sotto l'header principale
 */
export const MainNavigation = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/shop',
      label: 'Shop',
      icon: Package,
      exact: true
    },
    {
      path: '/shop/laundry-management',
      label: 'Reti e Transfer',
      icon: Shirt
    },
    {
      path: '/shop/gestione-restituzioni',
      label: 'Restituzione Oggetti',
      icon: Undo
    }
  ];

  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={swissClass(
      SWISS_HEADER.sticky,
      'shadow-none border-b-2' // Stronger border for emphasis
    )}>
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path, item.exact);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={swissClass(
                  'min-h-[40px]', // Ridotto da 44px a 40px
                  SWISS_TRANSITIONS.colors,
                  'px-3 flex items-center gap-1.5 relative', // Ridotto padding e gap
                  'text-xs font-medium uppercase tracking-wide', // Ridotto da text-sm a text-xs
                  'border-b-2 -mb-[2px]', // Offset for border overlap
                  active
                    ? 'border-gray-900 text-gray-900' // Active state
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                )}
              >
                <Icon className="w-3.5 h-3.5" /> {/* Ridotto da w-4 h-4 */}
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default MainNavigation;
